import { prepareHtml } from 'core/common/utils/prepareHtml';
import { RelationshipType, SectionUserDetailsAttributes } from 'core/flow/entities';
import { UserProfile } from 'core/user/entities';
import { getZodiacPersonImage } from 'core/zodiac/utils/getZodiacPersonImage';
import {
  ImageStyled,
  ImageWrapperStyled,
  InfoListStyled,
  InfoListWrapperStyled,
  LabelSectionItemStyled,
  LabelSectionWrapperStyled,
  SingleInfoListStyled,
  WrapperStyled,
} from './styled';

type UserDetailsProps = {
  content: SectionUserDetailsAttributes['content'];
  userPreferences: UserProfile;
};

export const UserDetails = ({ content, userPreferences }: UserDetailsProps) => {
  const { partner, user } = content;

  const { partnerInfoList, partnerSectionTitle } = partner || {};
  const { userInfoList, userSectionTitle } = user || {};

  const { relationshipType, zodiac, gender } = userPreferences;
  const zodiacImage = getZodiacPersonImage(zodiac, gender);
  const partnerZodiacImage = getZodiacPersonImage(
    userPreferences.partnerZodiac,
    userPreferences.partnerGender,
  );

  if (relationshipType === RelationshipType.SINGLE) {
    return (
      <WrapperStyled>
        <ImageWrapperStyled>
          <ImageStyled width={100} height={150} src={zodiacImage} alt="user zodiac image" />
        </ImageWrapperStyled>
        <SingleInfoListStyled list={userInfoList} />
      </WrapperStyled>
    );
  }

  return (
    <WrapperStyled>
      <ImageWrapperStyled>
        <LabelSectionWrapperStyled>
          <LabelSectionItemStyled
            variant="bodyMediumSemiBold"
            dangerouslySetInnerHTML={prepareHtml(userSectionTitle)}
          />
          <LabelSectionItemStyled
            variant="bodyMediumSemiBold"
            dangerouslySetInnerHTML={prepareHtml(partnerSectionTitle)}
          />
        </LabelSectionWrapperStyled>
        <ImageStyled width={100} height={150} src={zodiacImage} alt="user zodiac image" />
        <ImageStyled width={100} height={150} src={partnerZodiacImage} alt="partner zodiac image" />
      </ImageWrapperStyled>
      <InfoListWrapperStyled>
        <InfoListStyled list={userInfoList} />
        <InfoListStyled list={partnerInfoList} />
      </InfoListWrapperStyled>
    </WrapperStyled>
  );
};
